import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button/index';
import TextField from '@material-ui/core/TextField/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Zoom from '@material-ui/core/Zoom';
import {Add, CancelOutlined, SaveOutlined, AddOutlined, DeleteOutlined} from '@material-ui/icons';
import Fab from "@material-ui/core/Fab";
import {VentasRapidasService} from '../../../../services/VentasRapidasService/VentasRapidasService';
import IconButton from "@material-ui/core/IconButton";
import EditOutlined from '@material-ui/icons/EditOutlined';
import SearchOutlined from '@material-ui/icons/SearchOutlined';
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {CadenaDomicilio, EnteroSolo, FieldsJs} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import AutoCompleteCliente from "../../OrdenDeVenta/Includes/AutoCompleteCliente";
import ModalCliente from "../../Cliente/Includes/ModalCliente";
import Typography from "@material-ui/core/Typography";
import add_cliente_venta from "../../../../assets/img/icons/add-cliente-venta.svg";
import edit_cliente_venta from "../../../../assets/img/icons/edit-cliente-venta.svg";
import view_cliente_venta from "../../../../assets/img/icons/view-cliente-venta.svg";
import carnet_identificacion from "../../../../assets/img/icons/carnet-de-identidad.svg";
import {ClienteService} from "../../../../services/ClienteService/ClienteService";
import VistaVacia from "../../../Include/VistaVacia/VistaVacia";
import carrito_de_3 from "../../../../assets/img/icons/carro-de-la-compra-3.svg";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import {KeyboardDatePicker} from '@material-ui/pickers';
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {CONFIG} from "../../../../settings/Config/Config";


const formulario = {
	id_cliente: null,
	id_cat_tipo_persona: 1,
	tipo_persona: 'fisica',
	razon_social: '',
	nombre: '',
	apellido_paterno: '',
	apellido_materno: '',
	activo: true,
	
	id_cliente_direccion: null,
	calle: '',
	numero_exterior: '',
	numero_interior: '',
	codigo_postal: '',
	colonia: '',
	id_cat_estado: '',
	id_cat_municipio: '',
	estado: '',
	municipio: '',
	
	ids_cliente_como_te_enteraste: [],
	
};

class ModalVentasRapidas extends Component {
	
	Usr = {};
	state = {};
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			modal: {
				open: false
			},
			
			tipo: props.tipo,
			
			id_venta_rapida: props.id_venta_rapida || 0,
			id_cat_grupo: '',
			id_cat_categoria: '',
			clave: '',
			producto: '',
			descripcion: '',
			precio_unitario: '',
			codigo_descuento: '',
			imagen_base64Tipo: '',
			imagen_base64: '',
			imagen_archivo: '',
			imagen_formato: '',
			activo: true,
			concepto: '',
			cantidad: '',
			importe: '',
			fecha: null,
			form: formulario,
			form_seleccionado: {},
			numero_pedido: '',
			desglose: '',
			numero_cotizacion: '',
			id_cliente: '',
			clientes_datos_suggestions: [],
			lista_ordenes: [],
			descuento: 0,
			descuento_general: '',
			
			lista_grupo: [],
			lista_categoria: [],
		};
	}
	
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}))
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
		console.log(this.state, props);
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve, reject) => {
			this.ListarDeCliente();
			resolve(true);
		});
	};
	
	ListarDeCliente = () => {
		ClienteService.Listar({activo: 1}, {}).then((response) => {
			
			let clt = response.data;
			
			let form = this.state.form;
			for (let i = 0; i < clt.length; i++) {
				if (Number(clt[i].id_cliente) === Number(form.id_cliente)) {
					form = clt[i];
				}
			}
			
			let form_seleccionado = this.state.form_seleccionado;
			for (let i = 0; i < clt.length; i++) {
				if (Number(clt[i].id_cliente) === Number(form_seleccionado.id_cliente)) {
					form_seleccionado = clt[i];
				}
			}
			
			this.setState({
				clientes_datos_suggestions: clt,
				form: form,
				form_seleccionado: form_seleccionado,
			});
		});
	};
	
	save = () => {
		VentasRapidasService.Guardar(this.state).then((response) => {
			this.close();
			this.props.RefreshList();
			this.props.showSnackBars('success', response.mensaje);
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});
	};
	
	add = () => {
		console.log(this.props);
		this.setState({
			id_venta_rapida: '',
			concepto: '',
			descripcion: '',
			cantidad: '',
			precio_unitario: '',
			importe: '',
			fecha: null,
			activo: true,
		});
		this.open();
	};
	
	edit = () => {
		const {id_venta_rapida, item} = this.props;
		console.log(this.props);
		this.setState({
			id_venta_rapida: id_venta_rapida || '',
			fecha: item.fecha || '',
			cliente: item.cliente || '',
			id_cliente: item.id_cliente || '',
			concepto: item.concepto || '',
			cantidad: item.cantidad || '',
			precio_unitario: item.precio_unitario || '',
			importe: item.importe || '',
			lista_ordenes: item.partidas || '',
			activo: (item.activo === 1),
		}, () => {
			if (FieldsJs.Field(item.id_cliente))
				this.RefreshListCliente(item.id_cliente);
		});
		this.open();
	};
	
	view = () => {
		const {id_venta_rapida, item} = this.props;
		console.log(this.props);
		this.setState({
			id_venta_rapida: id_venta_rapida || '',
			fecha: item.fecha || '',
			cliente: item.cliente || '',
			id_cliente: item.id_cliente || '',
			concepto: item.concepto || '',
			cantidad: item.cantidad || '',
			precio_unitario: item.precio_unitario || '',
			importe: item.importe || '',
			lista_ordenes: item.partidas || '',
			activo: (item.activo === 1),
		}, () => {
			if (FieldsJs.Field(item.id_cliente))
				this.RefreshListCliente(item.id_cliente);
		});
		this.open();
	};
	
	delete = (value, key) => {
		try {
			PopupService.Confirm(['Cancelar', 'Aceptar'], 'warning', CONFIG.titulo_alert_confirm, '¿Deseas eliminar la partida?').then((r) => {
				if (r.button === 'Aceptar') {
					let lista_ordenes = FieldsJs.Copy(this.state.lista_ordenes);
					
					lista_ordenes.splice(key, 1);
					
					this.setState({
						lista_ordenes: lista_ordenes
					});
					
					this.calcularTotalCompra();
				}
			});
			
		} catch (error) {
			this.showSnackBars('error', error.mensaje);
		}
	};
	
	is_view = () => {
		return this.props.tipo === 'view';
	};
	
	is_edit = () => {
		return this.props.tipo === 'edit';
	};
	
	is_add = () => {
		return this.props.tipo === 'add';
	};
	
	is_edited_product = () => {
		return this.state.key !== null && this.state.key > -1;
	};
	
	is_root = () => {
		return FieldsJs.inArray([1], this.Usr.id_cat_tipo_usuario);
	};
	
	BOTON_ACCION = () => {
		var BTN_ACTION = '';
		
		if (this.state.id_venta_rapida > 0) {
			if (this.state.tipo === 'edit') {
				BTN_ACTION = (
					<Tooltip TransitionComponent={Zoom} placement={"top"} title="Editar">
						<IconButton aria-label="Editar" onClick={() => this.edit()}>
							<EditOutlined/>
						</IconButton>
					</Tooltip>
				);
			} else if (this.state.tipo === 'view') {
				BTN_ACTION = (
					<Tooltip TransitionComponent={Zoom} placement={"top"} title="Detalles">
						<IconButton aria-label="Detalles" onClick={() => this.view()}>
							<SearchOutlined/>
						</IconButton>
					</Tooltip>
				);
			}
		} else {
			BTN_ACTION = (
				<Zoom className={'btn-fixed-bottom-right cursor-pointer'} key={'inherit'} timeout={1500} in={true}
				      style={{transitionDelay: `${100}ms`}} unmountOnExit>
					<Fab color={'primary'} onClick={() => this.add()}>
						<Add/>
					</Fab>
				</Zoom>
			);
		}
		return BTN_ACTION;
	};
	
	RefreshListCliente = (id_cliente) => {
		console.log(id_cliente, this.state)
		if (id_cliente > 0) {
			this.update_campos_tipo_persona();
			setTimeout(() => {
				let form = FieldsJs.Copy(this.state.form);
				form.id_cliente = id_cliente;
				this.setState({
					id_cliente: form.id_cliente,
					form: FieldsJs.Copy(form),
					form_seleccionado: FieldsJs.Copy(form),
				});
				console.log('111111', form);
				this.ListarDeCliente();
			});
		} else {
			this.update_campos_tipo_persona();
			setTimeout(() => {
				let form = FieldsJs.Copy(this.state.form);
				this.setState({
					id_cliente: this.state.form.id_cliente,
					form: FieldsJs.Copy(form),
					form_seleccionado: FieldsJs.Copy(form),
				});
				console.log('000000', form);
				this.ListarDeCliente();
			});
		}
	};
	
	update_campos_tipo_persona = () => {
		if (this.state.form.tipo_persona === "moral") {
			let form = this.state.form;
			form.id_cat_tipo_persona = 2;
			form.nombre = '';
			form.apellido_paterno = '';
			form.apellido_materno = '';
			this.setState({
				form: form,
				form_seleccionado: form
			});
		}
		
		if (this.state.form.tipo_persona === "fisica") {
			let form = this.state.form;
			form.id_cat_tipo_persona = 1;
			form.razon_social = '';
			this.setState({
				form: form,
				form_seleccionado: form
			})
		}
	};
	
	handleChangeSingle = (e, name) => {
		console.log(name, e);
		
		let form = FieldsJs.Copy(formulario);
		
		for (let i = 0; i < this.state.clientes_datos_suggestions.length; i++) {
			if (this.state.clientes_datos_suggestions[i].id_cliente === e.value) {
				for (let key in formulario) {
					form[key] = this.state.clientes_datos_suggestions[i][key];
				}
			}
		}
		
		this.setState({
			[name]: e.value,
			form: FieldsJs.Copy(form),
			form_seleccionado: FieldsJs.Copy(form)
		});
	};
	
	getCatTipoRequerimiento = (e) => {
		const {value, name, checked, type} = e.target;
		CatService.ListTipoRequerimiento(value).then((response) => {
			this.setState({
				cat_tipo_requerimiento: response.data
			});
		});
	};
	
	update_product = (key) => {
		return new Promise(resolve => {
			let productos = this.state.productos;
			for (let i = 0; i < productos.length; i++) {
				if (key === i) {
					productos[i].venta_producto_tipo_requerimiento = []
				}
			}
			this.setState({
				productos: productos
			});
			resolve(true)
		})
	}
	
	edit_orden = () => {
		this.setState({
			key: null,
			id_venta_rapida: '',
			producto: '',
			descripcion: '',
			cantidad: '',
			precio_unitario: '',
			total: '',
			iva_incluido: false,
			iva_aplicado: false,
			ordenes_venta: [],
			descuento: '',
		});
	};
	
	edit_partida = (value, index) => {
		this.setState({
			key: index,
			id_venta_rapida_partida: value.id_venta_rapida_partida || '',
			concepto: value.concepto || '',
			descripcion: value.id_venta_rapida_partida || '',
			cantidad: value.cantidad || '',
			precio_unitario: value.precio_unitario || '',
			importe: value.importe || '',
			iva_incluido: false,
			iva_aplicado: false,
			descuento: 0,
		});
	};
	
	is_edited_orden = () => {
		return this.state.key !== null && this.state.key > -1;
	};
	
	add_orden = () => {
		
		try {
			
			if (!this.state.concepto) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Concepto.'
				})
			}
			
			if (!(this.state.cantidad > 0)) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Cantidad.'
				})
			}
			
			if (!(this.state.precio_unitario > 0)) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Precio Unitario.'
				})
			}
			
			if (!(this.state.importe > 0)) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Importe.'
				})
			}
			
			/*if (!(this.state.fecha > 0)) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Fecha.'
				})
			}*/
			
			/*if (!(this.state.total > 0)) {
				throw Object({
					status: false, mensaje: 'Campo requerido: Total.'
				})
			}*/
			
			let lista_ordenes = FieldsJs.Copy(this.state.lista_ordenes || []);
			
			if (this.is_edited_product()) {
				for (let i = 0; i < lista_ordenes.length; i++) {
					let item = lista_ordenes[i];
					if (this.state.key === i) {
						item.concepto = this.state.concepto || '';
						item.cantidad = this.state.cantidad || 0;
						item.precio_unitario = this.state.precio_unitario || 0;
						item.importe = this.state.importe || 0;
						item.iva_incluido = this.state.iva_incluido ? 1 : 0;
						item.iva_aplicado = this.state.iva_aplicado ? 1 : 0;
						item.descuento = this.state.descuento;
						item.descuento_general = this.state.descuento_general;
					}
				}
			} else {
				let item;
				item = {
					concepto: this.state.concepto || '',
					cantidad: this.state.cantidad || 0,
					precio_unitario: this.state.precio_unitario || 0,
					importe: this.state.importe || 0,
					iva_incluido: this.state.iva_incluido ? 1 : 0,
					iva_aplicado: this.state.iva_aplicado ? 1 : 0,
					descuento: this.state.descuento,
					descuento_general: this.state.descuento_general,
				};
				lista_ordenes.push(item);
			}
			
			this.setState({
				key: null,
				concepto: '',
				cantidad: '',
				precio_unitario: '',
				importe: '',
				descuento: '',
				descuento_general: '',
				iva_incluido: false,
				iva_aplicado: false,
				lista_ordenes: lista_ordenes
			});
			console.log(this.state);
			this.calcularTotalCompra();
			
			setTimeout(() => {
				this.setState({
					desglose: this.calcularDesgoseTotales()
				})
			}, 800);
		} catch (e) {
			console.error(e);
			this.props.showSnackBars('error', e.mensaje);
		}
	};
	
	calcularTotalConSinIVASuma = (value) => {
		if (FieldsJs.Field(value.iva_incluido) && value.iva_incluido === 1) {
			return this.calcularSubTotalConSinIVA(value);
		} else {
			return Number(value.importe);
		}
	};
	
	calcularDescuento = (value) => {
		return Number(value.descuento);
	};
	
	calcularTotalConSinIVA = (value) => {
		if (value.iva_incluido === 1 || value.iva_aplicado === 1) {
			return this.calcularSubTotalConSinIVA(value) + this.calcularIVA(value);
		} else {
			return this.calcularSubTotalConSinIVA(value) * 1.16;
		}
	};
	
	calcularIVA = (value) => {
		if (value.iva_aplicado === 0) {
			if (value.iva_incluido === 1) {
				return value.compra_total - (value.compra_total / 1.16);
				//return this.calcularSubTotalConSinIVA(value) * 0.16;
			} else {
				return this.calcularSubTotalConSinIVA(value) * 0.16;
			}
		} else {
			return 0;
		}
	};
	
	calcularSubTotalConSinIVA = (value) => {
		if (value.iva_incluido === 1 && value.iva_aplicado === 0) {
			return ((Number(value.importe) / 1.16) - Number(value.descuento));
		} else {
			return Number(value.importe);
		}
	};
	
	calcularTotalConSinIVAPrecioUnitario = (value) => {
		return (this.calcularSubTotalConSinIVAPrecioUnitarioNew(value) + this.calcularIVAPrecioUnitarioNew(value));
	};
	
	calcularIVAPrecioUnitarioNew = (value) => {
		if (value.iva_incluido === 1 || value.iva_aplicado === 1) {
			return Number(value.precio_unitario) - (Number(value.precio_unitario) / 1.16);
		} else {
			return ((this.calcularSubTotalConSinIVAPrecioUnitario(value) - (Number(value.descuento) / Number(value.cantidad))) * 0.16);
		}
	};
	
	calcularPrecioUnitarioProducto = () => {
		setTimeout(() => {
			let compra_cantidad = this.state.cantidad || 1;
			let compra_precio_unitario = 0;
			let compra_total = this.state.importe;
			
			if (compra_cantidad > 0 && compra_total > 0) {
				if (this.state.iva_aplicado === 0) {
					compra_precio_unitario = (compra_total / compra_cantidad);
				}
			}
			
			this.setState({
				cantidad: compra_cantidad,
				precio_unitario: compra_precio_unitario
			});
		});
	};
	
	calcularSubTotalConSinIVAPrecioUnitario = (value) => {
		if (value.iva_incluido === 1 && value.iva_aplicado === 0) {
			return Number(value.precio_unitario) / 1.16;
		} else {
			return Number(value.precio_unitario);
		}
	};
	
	calcularSubTotalConSinIVAPrecioUnitarioNew = (value) => {
		return (this.calcularSubTotalConSinIVAPrecioUnitario(value) - (Number(value.descuento) / Number(value.cantidad)));
	};
	
	calcularIVAPrecioUnitario = (value) => {
		if (value.iva_aplicado === 0) {
			if (value.iva_incluido === 1) {
				return Number(value.precio_unitario) - (Number(value.precio_unitario) / 1.16);
			} else {
				return Number(value.precio_unitario) * 0.16;
			}
		} else {
			return 0;
		}
	};
	
	calcularTotalCompra = () => {
		setTimeout(() => {
			let lista_compra_producto = this.state.lista_compra_producto || [];
			let total = 0;
			for (let i = 0; i < lista_compra_producto.length; i++) {
				let item = lista_compra_producto[i];
				if (Number(item.compra_total) > 0) {
					total += this.calcularTotalConSinIVA(item);
				}
			}
			this.setState({
				total: total
			});
			
			this.calcularDescuentoGeneral(this.state.descuento_general);
		});
	};
	
	calcularDescuentoGeneral = (valor) => {
		let lista_ordenes = this.state.lista_ordenes || [];
		for (let i = 0; i < lista_ordenes.length; i++) {
			let item = lista_ordenes[i];
			if (i === 0) {
				item.descuento_general = Number(item.descuento) + Number(valor || 0);
			} else {
				item.descuento_general = 0;
			}
		}
		this.setState({
			lista_ordenes: lista_ordenes
		});
	};
	
	calcularDesgoseTotales = () => {
		let desglose = {
			suma: 0,
			subtotal: 0,
			descuento: 0,
			iva: 0,
			total: 0,
		};
		let lista_ordenes = FieldsJs.Copy(this.state.lista_ordenes);
		for (let i = 0; i < lista_ordenes.length; i++) {
			let item = lista_ordenes[i];
			desglose.suma += this.calcularTotalConSinIVASuma(item);
			//desglose.subtotal += this.calcularSubTotalConSinIVA(item);
			desglose.descuento += this.calcularDescuento(item);
			desglose.iva += this.calcularIVA(item);
			desglose.total += this.calcularTotalConSinIVA(item);
		}
		desglose.descuento = desglose.descuento + Number(this.state.descuento_general);
		desglose.subtotal = Number(desglose.suma) - Number(desglose.descuento);
		//desglose.iva = desglose.subtotal * 0.16;
		desglose.total = Number(desglose.subtotal) + Number(desglose.iva);
		
		
		return desglose;
	};
	
	calcularImporte = (cantidad, precio) => {
		this.setState({
			importe: cantidad * precio
		})
	}
	
	render() {
		
		const BTN_ACTION = this.BOTON_ACCION();
		
		const btn_add = {
			backgroundImage: `url(${add_cliente_venta})`,
			opacity: 1
		};
		
		const btn_edit = {
			backgroundImage: `url(${edit_cliente_venta})`,
			opacity: this.state.form_seleccionado.id_cliente > 1 ? 1 : 0.5
		};
		
		const btn_view = {
			backgroundImage: `url(${view_cliente_venta})`,
			opacity: this.state.form_seleccionado.id_cliente > 1 ? 1 : 0.5
		};
		
		const lista_vacia_datos_cliente = {
			backgroundImage: `url(${carnet_identificacion})`,
			opacity: 0.5
		};
		
		let desglose = this.calcularDesgoseTotales();
		
		return (
			<div>
				
				{BTN_ACTION}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'md'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>{this.state.tipo === 'edit' ? 'Actualizar' : (this.state.tipo === 'view' ? 'Detalle' : 'Agregar')} Venta Rápida</DialogTitle>
					
					<DialogContent className={'padding-20'}>
						
						<Grid container spacing={2}>
							
							<Grid item xs={12} sm={12} md={10} lg={10} xl={10} className={'h-60-px'}>
								
								{this.is_view() ? (
									<Fragment>
										{this.state.numero_pedido || this.state.numero_cotizacion ? (
											<Typography className={'text-left text-danger px-20'}>
												{this.state.numero_pedido || this.state.numero_cotizacion}
											</Typography>
										) : ''}
										<div className={'vertical-inline h-100'}>
											<Typography className={'v-center text-center px-14'}>
												{this.state.cliente}
											</Typography>
										</div>
										
									</Fragment>
								) : (
									<Fragment>
										<div className={'row-flex h-52-px'}>
											<div className="w-100-120-px">
												<AutoCompleteCliente
													handleChangeSingle={this.handleChangeSingle}
													suggestions={this.state.clientes_datos_suggestions}
													value={this.state.id_cliente}
													name={'id_cliente'} id={'id_cliente'}
													label={'nombre_completo'}
												/>
											</div>
											
											<div className="w-40-px vertical-inline">
												<div className={'w-100 v-end'} align={'right'}>
													<ModalCliente
														tipo={'view'}
														item={this.state.form_seleccionado}
														RefreshList={() => this.RefreshListCliente(null)}
														showSnackBars={this.props.showSnackBars}
														componente={(
															<div
																className={'w-30-px h-30-px b-r-7 bg-danger bg-img-cover-x-center-y-center cursor-pointer'}
																style={btn_view}
															/>
														)}
													/>
												</div>
											</div>
											<div className="w-40-px vertical-inline">
												<div className={'w-100 v-end'} align={'right'}>
													<ModalCliente
														tipo={'edit'}
														item={this.state.form_seleccionado}
														RefreshList={() => this.RefreshListCliente(null)}
														showSnackBars={this.props.showSnackBars}
														componente={(
															<div
																className={'w-30-px h-30-px b-r-7 bg-danger bg-img-cover-x-center-y-center cursor-pointer'}
																style={btn_edit}
															/>
														)}
													/>
												</div>
											</div>
											<div className="w-40-px vertical-inline">
												<div className={'w-100 v-end'} align={'right'}>
													<ModalCliente
														tipo={'add'}
														item={{}}
														RefreshList={(id_cliente) => this.RefreshListCliente(id_cliente)}
														showSnackBars={this.props.showSnackBars}
														componente={(
															<div
																className={'w-30-px h-30-px b-r-7 bg-danger bg-img-cover-x-center-y-center cursor-pointer'}
																style={btn_add}
															/>
														)}
													/>
												</div>
											</div>
										</div>
									</Fragment>
								
								)}
							
							</Grid>
							
							<Grid item className={'text-left'} xs={12} sm={12} md={2} lg={2} xl={2}>
								<KeyboardDatePicker
									format={'dd/MM/yyyy'} fullWidth required clearable
									inputProps={{readOnly: true}}
									KeyboardButtonProps={{
										'aria-label': 'change date',
										/*disabled: disabledInputVentaEditar*/
									}}
									label="Fecha"
									/*helperText={'Fecha entrega'}*/
									value={this.state.fecha}
									onChange={(date) => {
										this.handleChange(null, null, null, date, 'fecha');
									}}
									clearLabel={'Limpiar'}
									okLabel={'Aceptar'}
									cancelLabel={'Cancelar'}
									disabled={this.state.tipo === 'view'}
								/>
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={'h-60-px'}>
								<Card className={'borde-punteado-gray-1 padding-0 h-100'}>
									<CardContent className={'padding-5 h-100-12-px'}>
										
										{this.state.form_seleccionado.id_cliente !== 1 && (CadenaDomicilio(this.state.form_seleccionado) || this.state.form_seleccionado.rfc || this.state.form_seleccionado.correo_electronico || this.state.form_seleccionado.telefono || this.state.form_seleccionado.celular) ? (
											<Fragment>
												
												<div className={'w-100 h-100 vertical-inline'}>
													<div className={'w-100 v-center'} align={'center'}>
														
														{this.state.form_seleccionado.rfc ? (
															<Typography className={'px-14 text-left l-h-14'}>
																R.F.C.: {this.state.form_seleccionado.rfc}
															</Typography>
														) : ''}
														
														{this.state.form_seleccionado.correo_electronico || this.state.form_seleccionado.telefono || this.state.form_seleccionado.celular ? (
															<Typography className={'px-14 text-left l-h-14'}>
																{this.state.form_seleccionado.correo_electronico ? (
																	<span>{this.state.form_seleccionado.correo_electronico} </span>) : ''}
																{this.state.form_seleccionado.telefono ? (
																	<span>|  Tel: {this.state.form_seleccionado.telefono} </span>) : ''}
																{this.state.form_seleccionado.celular ? (
																	<span>|  Cel: {this.state.form_seleccionado.celular}</span>) : ''}
															</Typography>
														) : ''}
														
														{/*{CadenaDomicilio(this.state.form_seleccionado) ? (
																<Typography className={'px-12 text-left l-h-14'}>
																	{CadenaDomicilio(this.props.form.form_seleccionado)}
																</Typography>
															) : ''}*/}
													
													</div>
												</div>
											
											</Fragment>
										) : (
											<Fragment>
												<div className={'w-100 h-100 vertical-inline'}>
													<div className={'w-100 v-center'} align={'center'}>
														
														<div style={lista_vacia_datos_cliente}
														     className={'w-30-px h-30-px bg-img-cover-x-center-y-center'}/>
														
														<Typography color="textSecondary"
														            className={'px-14 text-center l-h-14'}>
															Venta para el publico en general
														</Typography>
													
													</div>
												</div>
											
											</Fragment>
										)}
									
									</CardContent>
								</Card>
							
							</Grid>
							
							{!this.is_view() ? (
								<Fragment>
									
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
										
										<TextField
											fullWidth
											onChange={this.handleChange}
											disabled={this.state.tipo === 'view'}
											required
											type="text"
											margin="none"
											name="concepto"
											label="Concepto"
											value={this.state.concepto}
										/>
									
									</Grid>
									
									<Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
										
										<TextField
											fullWidth
											onChange={(e) => {
												this.handleChange(e);
												this.calcularImporte(e.target.value, this.state.precio_unitario);
											}}
											disabled={this.state.tipo === 'view'}
											required
											type="text"
											margin="none"
											onKeyPress={EnteroSolo}
											inputProps={{maxLength: 10}}
											name="cantidad"
											label="Cantidad"
											value={this.state.cantidad}
										/>
									
									</Grid>
									
									<Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
										
										<TextField
											fullWidth
											onChange={(e) => {
												this.handleChange(e);
												this.calcularImporte(this.state.cantidad, e.target.value);
											}}
											disabled={this.state.tipo === 'view'}
											required
											type="text"
											margin="none"
											name="precio_unitario"
											label="Precio unitario"
											value={this.state.precio_unitario}
										/>
									
									</Grid>
									
									<Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
										
										<TextField
											fullWidth
											onChange={this.handleChange}
											disabled={this.state.tipo === 'view'}
											required
											type="text"
											margin="none"
											name="importe"
											label="Importe"
											value={this.state.importe}
										/>
									
									</Grid>
									
									<Grid item xs={6} sm={6} md={2} lg={2} xl={2} align={"right"}>
										<Tooltip
											TransitionComponent={Zoom}
											placement={"top"}
											title="Cancelar edición"
											children={(
												<span>
												<Fab size="small" color="secondary"
												     aria-label="Cancelar edición"
												     onClick={() => this.edit_orden()}
												     style={{marginLeft: "15px"}}
												     disabled={!this.is_edited_orden()}>
													<CancelOutlined/>
												</Fab>
											</span>
											)}
										/>
										<Tooltip
											TransitionComponent={Zoom}
											placement={"top"}
											title={this.is_edited_orden() ? "Actualizar" : "Agregar"}
											children={(
												<Fab size="small" color="secondary"
												     aria-label={this.is_edited_orden() ? "Actualizar" : "Agregar"}
												     onClick={() => this.add_orden()}
												     style={{marginLeft: "15px"}}>
													{this.is_edited_orden() ? (
														<SaveOutlined/>
													) : (
														<AddOutlined/>
													)}
												</Fab>
											)}
										/>
									</Grid>
								</Fragment>
							) : null}
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<table className={'desing-mark'}>
									<thead>
									<tr>
										{!this.is_view() ? (<th style={{width: '120px'}} align={'center'}>Acciones</th>):null}
										<th align={'left'}>Concepto</th>
										<th align={'right'}>Cantidad</th>
										<th align={'right'}>Precio Unitario</th>
										<th align={'right'}>Importe</th>
									</tr>
									</thead>
									<tbody>
									{this.state.lista_ordenes.map((value, index) => (
										<tr key={index}>
											{!this.is_view() ? (
												<td style={{width: '120px'}} align={'center'}>
													<Tooltip
														TransitionComponent={Zoom}
														placement={"top"}
														title="Eliminar"
														children={(
															<Fab
																size="small"
																aria-label="Eliminar"
																onClick={() => this.delete(value, index)}
																style={{
																	backgroundColor: "transparent",
																	color: "#808080",
																	boxShadow: "none",
																}}
																children={(
																	<DeleteOutlined/>
																)}
															/>
														)}
													/>
													{this.state.key === index ? (
														<Tooltip
															TransitionComponent={Zoom}
															placement={"top"}
															title="Producto en edición"
															children={(
																<Fab
																	size="small"
																	aria-label="Editar"
																	onClick={() => this.edit_partida(value, index)}
																	style={{
																		marginLeft: "10px",
																		backgroundColor: "#f50057",
																		color: "white",
																	}}
																	children={(
																		<EditOutlined/>
																	)}
																/>
															)}
														/>
													) : (
														<Tooltip
															TransitionComponent={Zoom}
															placement={"top"}
															title="Editar producto"
															children={(
																<Fab
																	size="small"
																	aria-label="Editar"
																	onClick={() => this.edit_partida(value, index)}
																	style={{
																		marginLeft: "10px",
																		backgroundColor: "transparent",
																		color: "#808080",
																		boxShadow: "none",
																	}}
																	children={(
																		<EditOutlined/>
																	)}
																/>
															)}
														/>
													)}
												</td>
											) : null}
											
											<td align={"left"}>{value.concepto}</td>
											<td align={"right"}>{value.cantidad}</td>
											<td align={"right"}>${FieldsJs.Currency(value.precio_unitario)}</td>
											<td align={"right"}>${FieldsJs.Currency(value.importe)}</td>
										
										</tr>
									))}
									{!(this.state.lista_ordenes.length > 0) ? (
										<tr>
											<td colSpan={5} align={'center'}>
												<VistaVacia
													numero={null}
													mensaje={'Ningún concepto agregado'}
													image={carrito_de_3}
													padding={'20px'}
													paddingText={'20px'}
													height={'80px'}
													width={'80px'}
												/>
											</td>
										</tr>
									) : null}
									<tr>
										<td colSpan={5} align={'center'}>
											&nbsp;
										</td>
									</tr>
									<tr>
										{!this.is_view() ? (<td colSpan={3}></td>):(<td colSpan={2}></td>)}
										<td align={"right"}>
											{/*<div className={'vertical-inline'}>
												<div className={'v-center w-200-px margin-15-R'}>
													<TextField
														margin="none"
														name="descuento_general"
														type="text"
														fullWidth
														value={this.state.descuento_general}
														onChange={(e) => {
															this.handleChange(e);
															this.calcularDescuentoGeneral(e.target.value);
														}}
														inputProps={{
															placeholder: "Descuento general",
															maxLength: 50
														}}
														onKeyPress={EnteroSolo}
														disabled={this.props.tipo === 'view'}
													/>
												</div>
												
												<div className={'v-center'}>
													Suma
												</div>
											</div>*/}
											Suma
										</td>
										<td align={"right"}>${FieldsJs.Currency(desglose.suma)}</td>
									</tr>
									<tr>
										{!this.is_view() ? (<td colSpan={3}></td>):(<td colSpan={2}></td>)}
										<td align={"right"}>Descuento</td>
										<td align={"right"}>${FieldsJs.Currency(desglose.descuento)}</td>
									</tr>
									<tr>
										{!this.is_view() ? (<td colSpan={3}></td>):(<td colSpan={2}></td>)}
										<td align={"right"}>Subtotal</td>
										<td align={"right"}>${FieldsJs.Currency(desglose.subtotal)}</td>
									</tr>
									<tr>
										{!this.is_view() ? (<td colSpan={3}></td>):(<td colSpan={2}></td>)}
										<td align={"right"}>IVA</td>
										<td align={"right"}>${FieldsJs.Currency(desglose.iva)}</td>
									</tr>
									<tr>
										{!this.is_view() ? (<td colSpan={3}></td>):(<td colSpan={2}></td>)}
										<td align={"right"}>
											<div style={{color: '#c12d2d', fontSize: '1.3rem'}}>Total</div>
										</td>
										<td align={"right"}>
											<div style={{color: '#c12d2d', fontSize: '1.3rem'}}>${FieldsJs.Currency(desglose.total)}</div>
										</td>
									</tr>
									</tbody>
								</table>
							</Grid>
						
						</Grid>
					
					</DialogContent>
					
					<Divider/>
					
					<DialogActions>
						
						<Button onClick={() => this.close()} color="primary">
							{this.state.tipo === 'view' ? 'Cerrar' : 'Cancelar'}
						</Button>
						
						{this.state.tipo !== 'view' ? (
							<Button onClick={() => this.save()} color="primary">
								{this.state.id_venta_rapida > 0 ? 'Actualizar' : 'Agregar'}
							</Button>
						) : ''}
					
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalVentasRapidas.propTypes = {
	id_venta_rapida: PropTypes.oneOfType([
		PropTypes.number.isRequired,
		PropTypes.oneOf([null]).isRequired,
	]),
	tipo: PropTypes.string.isRequired,
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default ModalVentasRapidas;
